// extracted by mini-css-extract-plugin
export default {"heading":"vv-z","corrected":"wv-z","redirectVerbiageContainer":"xv-z","redirectVerbiageText":"yv-z"};